import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FileExtension } from '../interfaces/file-extension';

@Injectable({
  providedIn: 'root'
})
export class FileExtensionsService {

  private readonly fileExtensionServiceUrl = '/apiconnect/parameters-vt/file-extensions/'

  constructor(private readonly http: HttpClient) { }

  getFeatureAllowedExtensions(feature: string): Observable<FileExtension> {
    const url = `${this.fileExtensionServiceUrl}${feature}`;
    return this.http.get<FileExtension>(url);
  }
}
